import { IFile } from '@aca-new/app/pages/book/pages/confirmation/shared/components/confirmation-order-summary/shared/interfaces/file.interface';
import { EPreviousCertificationSelectAction } from '@aca-new/app/pages/book/pages/food-certification/shared/components/food-general-information/shared/models/enums/previous-certification-select-action.enum';
import { ISelectPreviousCertification } from '@aca-new/app/pages/book/pages/food-certification/shared/components/food-general-information/shared/models/interfaces/select-previous-certification.interface';
import { IFoodCertificationOrderResponse } from '@aca-new/app/pages/book/pages/food-certification/shared/models/interfaces/food-certification-order.interface';
import { PreviousOrderLinkedRenewalWarnService } from '@aca-new/app/pages/book/pages/food-certification/shared/services/previous-order-linked-renewal-warn.service';
import { IPreviousOrders } from '@aca-new/app/pages/bookings/shared/models/interfaces/bookings.interface';
import { DataTableComponent } from '@aca-new/app/shared/components/data-table/data-table.component';
import { DataTableModule } from '@aca-new/app/shared/components/data-table/data-table.module';
import { ESortOrder } from '@aca-new/app/shared/components/data-table/shared/models/enums/sort-order.enum';
import { DataTableResponseType, IDataTableData, PageItemType } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-data.interface';
import { IDataTableQueryParams } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-query-params.interface';
import { DataTableService } from '@aca-new/app/shared/components/data-table/shared/service/data-table.service';
import { SelectAttachmentService } from '@aca-new/app/shared/components/file-upload/shared/components/select-attachments/shared/services/select-attachment.service';
import { DialogRef } from '@aca-new/app/shared/components/modal/shared/classes/dialog.ref';
import { DialogHeaderModule } from '@aca-new/app/shared/components/modal/shared/components/dialog-header/dialog-header.module';
import { DIALOG_DATA } from '@aca-new/app/shared/components/modal/shared/tokens/dialog.token';
import { ETableDataType } from '@aca-new/app/shared/components/table/shared/enums/table-data-type.enum';
import { ITableBodyCell, ITableBodyRow } from '@aca-new/app/shared/components/table/shared/interfaces/table-data.interface';
import { ITableHeader } from '@aca-new/app/shared/components/table/shared/interfaces/table-header.interface';
import { ITableSort } from '@aca-new/app/shared/components/table/shared/interfaces/table-sort.interface';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { FOOD_SERVICE_CONFIG_MAP } from '@aca-new/app/shared/constants/industry-data.constants';
import { TABLE_PAGINATION } from '@aca-new/app/shared/constants/table-pagination.constants';
import { LoadingDirective } from '@aca-new/app/shared/directives/loading/loading.directive';
import { EDocType } from '@aca-new/app/shared/models/enums/doc-type.enum';
import { ELoadingType } from '@aca-new/app/shared/models/enums/loading-type.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { IHttpResponseBody } from '@aca-new/app/shared/models/interfaces/http-response-body.interface';
import { QimaNullableType } from '@aca-new/app/shared/models/types/qima.type';
import { AppTableService } from '@aca-new/app/shared/services/exported-services/app-table/app-table.service';
import { QimaButtonService } from '@aca-new/app/shared/services/exported-services/qima-button/qima-button.service';
import { QimaDividerService } from '@aca-new/app/shared/services/exported-services/qima-divider/qima-divider.service';
import { QimaIconService } from '@aca-new/app/shared/services/exported-services/qima-icon/qima-icon.service';
import { QimaInputService } from '@aca-new/app/shared/services/exported-services/qima-input/qima-input.service';
import { AppFileService } from '@aca-new/app/shared/services/file-services/app-file.service';
import { HttpService } from '@aca-new/app/shared/services/http-services/http.service';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { EQimaTableHeadCellSort, QimaButtonModule, QimaCheckboxModule, QimaDividerModule, QimaInputTextModule } from '@qima/ngx-qima';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'app-select-previous-certification',
  templateUrl: './select-previous-certification.component.html',
  styleUrls: ['./select-previous-certification.component.scss'],
  providers: [DataTableService, SelectAttachmentService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    DialogHeaderModule,
    TranslateModule,
    LoadingDirective,
    QimaInputTextModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableModule,
    QimaDividerModule,
    QimaButtonModule,
    QimaCheckboxModule,
  ],
})
export class SelectPreviousCertificationComponent implements OnInit {
  @ViewChild(DataTableComponent) public dataTableComponent: DataTableComponent | undefined;

  public isLoading: boolean = true;
  public tableSelectRow: ITableBodyRow | undefined = undefined;
  public notFoundControl: FormControl<boolean | null> = new FormControl(false);
  public activePage: number = 1;
  public dataTableUrl: string = '';
  public readonly userId = this._storageService.getItem(EStorageKeys.USER_ID);
  public readonly pageSizes: number[] = [TABLE_PAGINATION.pageSize10, TABLE_PAGINATION.pageSize20, TABLE_PAGINATION.pageSize50, TABLE_PAGINATION.pageSize100];

  public readonly queryParams: IDataTableQueryParams = {
    keyword: '',
    pageSize: this.pageSizes[0],
    page: 1,
    sortField: '',
    sortType: undefined,
  };

  public readonly tableHeaders: ITableHeader[] = [
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      label: 'BOOKS.FOOD_CERTIFICATION.QIMA_REF_NO',
      type: ETableDataType.STRING,
      key: 'refNumber',
      sortKey: 'refNumber',
      width: '200',
    },
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      label: 'BOOKS.FOOD_CERTIFICATION.AUDIT_DATE',
      type: ETableDataType.STRING,
      key: 'auditDateFrom',
      sortKey: 'auditDateFrom',
      width: '200',
      cellTransform(cellData: ITableBodyCell, pageItem?: Record<string, PageItemType>): void {
        const fromDate = `${pageItem?.auditDateFrom}`;
        const toDate = `${pageItem?.auditDateTo}`;

        if (fromDate && toDate) {
          cellData.label = `${fromDate} to ${toDate}`;
        } else {
          cellData.label = '';
        }
      },
    },
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      label: 'BOOKS.FOOD_CERTIFICATION.CERTIFICATION_TYPES',
      type: ETableDataType.STRING,
      cellTransform(cellData: ITableBodyCell, pageItem?: Record<string, PageItemType>): void {
        const certificateTypes = (pageItem as Record<string, unknown>)?.certificateTypes as Array<{ certConstraint: string; certTypeText: string }> | undefined;

        if (Array.isArray(certificateTypes)) {
          const types = certificateTypes
            .filter((cert): boolean => cert.certConstraint === 'MAIN')
            .map((cert): string => cert.certTypeText)
            .filter(Boolean);

          cellData.label = types.join(', ') || '-';
        } else {
          cellData.label = '-';
        }
      },
      key: 'certificateTypes',
      sortKey: 'certTypeKey',
      width: '180',
    },
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      label: 'BOOKS.FOOD_CERTIFICATION.ANNOUNCEMENT_TYPE',
      type: ETableDataType.STRING,
      key: 'announcementType',
      sortKey: 'announcementType',
      width: '150',
    },
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      label: 'BOOKS.FOOD_CERTIFICATION.LEGAL_ENTITY',
      type: ETableDataType.STRING,
      key: 'producerLegalEntity',
      sortKey: 'producerLegalEntity',
      width: '180',
    },
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      label: 'BOOKS.FOOD_CERTIFICATION.FINISHED_PRODUCTS',
      type: ETableDataType.STRING,
      key: 'finishedProducts',
      sortKey: 'finishedProducts',
      width: '170',
      hide: this._dialogData?.serviceType === EServiceType.GGAP,
    },
  ];

  public readonly eLoadingType = ELoadingType;
  public readonly draftId: string | undefined;

  public constructor(
    private readonly _dialogRef: DialogRef<ISelectPreviousCertification>,
    @Inject(DIALOG_DATA) private readonly _dialogData: { draftId?: string; serviceType?: EServiceType },
    private readonly _storageService: StorageService,
    private readonly _appUserSettingService: AppUserSettingService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _httpService: HttpService,
    private readonly _appFileService: AppFileService,
    private readonly _selectAttachmentService: SelectAttachmentService,
    private readonly _previousOrderLinkedRenewalWarnService: PreviousOrderLinkedRenewalWarnService,
    public readonly qimaButton: QimaButtonService,
    public readonly qimaIcon: QimaIconService,
    public readonly qimaInput: QimaInputService,
    public readonly qimaDivider: QimaDividerService,
    public readonly appTable: AppTableService
  ) {
    this.draftId = this._dialogData?.draftId;
  }

  public ngOnInit(): void {
    this._setDataTableUrl();
    this._watchNotFoundCheckbox();
  }

  public transformSourceData(source: unknown): DataTableResponseType {
    if (source && typeof source === 'object' && 'content' in source) {
      const { content } = source as { content: IDataTableData };

      if (content?.pageItems) {
        return {
          pageItems: content.pageItems,
          totalSize: content.totalSize || 0,
          pageNo: content.pageNo?.toString() || '1',
        };
      }
    }

    if (source && typeof source === 'object' && 'pageItems' in source) {
      const data = source as IDataTableData;

      return {
        pageItems: data.pageItems || [],
        totalSize: data.totalSize || 0,
        pageNo: data.pageNo?.toString() || '1',
      };
    }

    return {
      pageItems: [],
      totalSize: 0,
      pageNo: '1',
    };
  }

  public onLoadingChange(isLoading: boolean): void {
    this.isLoading = isLoading;

    this._changeDetectorRef.markForCheck();
  }

  public onPaginationChange(page: number): void {
    this.activePage = page;
    this.queryParams.page = page;

    this._setDataTableUrl();
  }

  public onPageSizeChange(pageSize: number): void {
    this.queryParams.pageSize = pageSize;
    this.activePage = 1;
    this.queryParams.page = 1;

    this._setDataTableUrl();
  }

  public beforeTableRowClick = (): boolean => {
    return !this.notFoundControl.value;
  };

  public tableRowClick(tableRow: ITableBodyRow): void {
    this.tableSelectRow = tableRow;
    this._changeDetectorRef.markForCheck();
  }

  public close(): void {
    this._dialogRef.close();
  }

  public onSearchClear(): void {
    this.queryParams.keyword = '';
    this.activePage = 1;
    this.queryParams.page = 1;

    this._setDataTableUrl();
  }

  public onSearchEnter(): void {
    this.activePage = 1;
    this.queryParams.page = 1;

    this._setDataTableUrl();
  }

  public onCancel(): void {
    this._dialogRef.close();
  }

  public onDone(): void {
    if (this.notFoundControl.value) {
      this._dialogRef.close({ action: EPreviousCertificationSelectAction.NOT_FOUND });

      return;
    }

    if (!this.tableSelectRow) {
      return;
    }

    const originData = this.tableSelectRow.originData as IPreviousOrders;
    const previousOrderNumber = originData.refNumber || '';
    const orderId = originData.orderId || '';

    if (this._previousOrderLinkedRenewalWarnService.isShowWarning(previousOrderNumber, originData.linkedRenewalOrderNumbers)) {
      return;
    }

    if (!orderId) {
      console.error('Order ID is not available in the selected row');
      this._dialogRef.close({ action: EPreviousCertificationSelectAction.SELECTED, previousOrderNumber });

      return;
    }

    this.isLoading = true;
    this._changeDetectorRef.markForCheck();

    const docTypes: EDocType[] =
      this._dialogData?.serviceType === EServiceType.BRCGS ? [EDocType.HACCP_FLOW_DIAGRAM] : [EDocType.FOOD_CERT_ANNEX_022A, EDocType.FOOD_CERT_RENTED_SITE_CONTRACT_INFO];
    let url = `${SERVER_URL}/user/${this.userId}/wqs/order/${orderId}?serviceType=${this._dialogData?.serviceType ?? EServiceType.BRCGS}`;

    if (this._dialogData?.serviceType === EServiceType.GGAP && !this._appUserSettingService.getIsGgapOrderEnabled()) {
      url += '&oldVersion=true';
    }

    this._httpService.httpClient
      .get<IHttpResponseBody<QimaNullableType<IFoodCertificationOrderResponse>>>(url, {
        observe: 'response',
      })
      .pipe(
        switchMap(
          (
            response: Readonly<HttpResponse<IHttpResponseBody<QimaNullableType<IFoodCertificationOrderResponse>>>>
          ): Observable<HttpResponse<IHttpResponseBody<QimaNullableType<IFoodCertificationOrderResponse>>>> => {
            const orderDetails = response?.body?.content ?? null;

            if (!orderDetails || !this.draftId) {
              return of(response);
            }

            const { draftId } = this;
            // Process all document types in parallel
            const processDocTypeObservables = docTypes.map(
              (docType: EDocType): Observable<void | null> =>
                this._appFileService.getFiles$(draftId, docType).pipe(
                  switchMap((existingFiles: IFile[]): Observable<void | void[]> => {
                    if (!existingFiles || existingFiles.length === 0) {
                      return of(undefined);
                    }

                    const deleteObservables = existingFiles.map((file: IFile): Observable<void> => this._appFileService.deleteFile$(file.id));

                    return forkJoin(deleteObservables).pipe(catchError((): Observable<void[]> => of([])));
                  }),
                  switchMap((): Observable<IFile[]> => this._appFileService.getFiles$(orderId, docType)),
                  switchMap((files: IFile[]): Observable<void | null> => {
                    if (!files || files.length === 0) {
                      return of(null);
                    }

                    const fileIds = files.map((file: IFile): string => file.id).join(';');

                    return this._selectAttachmentService.copyAttachment$(fileIds, draftId);
                  })
                )
            );

            return forkJoin(processDocTypeObservables).pipe(
              map((): HttpResponse<IHttpResponseBody<QimaNullableType<IFoodCertificationOrderResponse>>> => response),
              catchError((error): Observable<HttpResponse<IHttpResponseBody<QimaNullableType<IFoodCertificationOrderResponse>>>> => {
                console.error('Error processing document types:', error);

                return of(response);
              })
            );
          }
        ),
        untilDestroyed(this)
      )
      .subscribe({
        next: (response: Readonly<HttpResponse<IHttpResponseBody<QimaNullableType<IFoodCertificationOrderResponse>>>>): void => {
          this.isLoading = false;
          this._changeDetectorRef.markForCheck();

          const orderDetails = response?.body?.content ?? null;

          this._dialogRef.close({
            action: EPreviousCertificationSelectAction.SELECTED,
            previousOrderNumber,
            orderDetails,
          });
        },
        error: (error): void => {
          this.isLoading = false;
          this._changeDetectorRef.markForCheck();
          console.error('Failed to fetch order details or copy files:', error);

          this._dialogRef.close({
            action: EPreviousCertificationSelectAction.SELECTED,
            previousOrderNumber,
            orderDetails: null,
          });
        },
      });
  }

  public onSortClick(sortEvent: ITableSort): void {
    this.queryParams.sortType = sortEvent.isSortAsc ? ESortOrder.ASC : ESortOrder.DESC;
    this.queryParams.sortField = sortEvent.sortKey;
    this.activePage = 1;
    this.queryParams.page = 1;

    this._setDataTableUrl();
  }

  private _watchNotFoundCheckbox(): void {
    this.notFoundControl.valueChanges.pipe(untilDestroyed(this)).subscribe((isChecked): void => {
      if (isChecked) {
        this.tableSelectRow = undefined;

        if (this.dataTableComponent) {
          this.dataTableComponent.resetTable();
        }
      }

      this._changeDetectorRef.markForCheck();
    });
  }

  private _setDataTableUrl(): void {
    if (!this.userId) {
      console.error('User ID is not available. Cannot construct data table URL.');
      this.dataTableUrl = '';
      this._changeDetectorRef.markForCheck();

      return;
    }

    const params = new URLSearchParams();

    params.append('status', '220');
    params.append('serviceTypes', this._dialogData?.serviceType ? (FOOD_SERVICE_CONFIG_MAP[this._dialogData.serviceType]?.code ?? '100') : '100');
    params.append('isRecert', 'true');
    params.append('page', this.queryParams.page.toString());
    params.append('page-size', this.queryParams.pageSize.toString());

    if (this.queryParams.keyword) {
      params.append('keyword', this.queryParams.keyword);
    }

    if (this.queryParams.sortField && this.queryParams.sortType) {
      params.append('sortField', this.queryParams.sortField);
      params.append('sortType', this.queryParams.sortType);
    }

    this.dataTableUrl = `${SERVER_URL}/user/${this.userId}/wqs/orders?${params.toString()}`;

    this._changeDetectorRef.markForCheck();
  }
}
